module.exports = __webpack_public_path__ + "img/caag1030_ideco.8eef3071.png";